import { createSlice } from '@reduxjs/toolkit';
import { emit } from '../websocket/websocketSlice'

const initialState = {
    weatherPreset: localStorage.getItem('weatherPreset') || 'sunny',
    weather: 'sunny',
};

/**
 * WeatherSlice - Redux Slice for Managing Weather State
 *
 * This slice manages the state of weather conditions in the application. It tracks whether 
 * the current weather is sunny, raining, or snowing, and provides actions to update the state.
 *
 * The slice is used to control and synchronize the weather state across the application, 
 * including sending weather data to Unity via WebSocket.
 *
 * Notes:
 * - At this moment, only basic weather states (sunny, snowing, raining) are tracked. 
 *   Future implementations could include additional attributes like wind speed, direction, or thunder.
 */
const weatherSlice = createSlice({
    name: 'weatherManager',
    initialState,
    reducers: {
        setWeatherPreset: (state, action) => {
            state.weatherPreset = action.payload;
            localStorage.setItem('weatherPreset', action.payload); // Save default settings in localStorage
            console.log("setWeatherPreset to", action.payload);
        },
        setWeather: (state, action) => {
            state.weather = action.payload; // Change session setting only
            console.log("setWeather to", action.payload);
        },
        initWeather: (state) => {
            state.weather = state.weatherPreset; // Set session setting to default
            emit({ type: 'manageWeather', command: state.weather });
            console.log("initWeather with", state.weatherPreset);
        }
    }
});

export const selectWeather = (state) => state.weatherManager.weather;
export const selectWeatherPreset = (state) => state.weatherManager.weatherPreset;
export const { setWeatherPreset, setWeather, initWeather } = weatherSlice.actions;

// Exporting the reducer
export default weatherSlice.reducer;
